import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../gql/api';
import i18n from '../../i18n';
import _ from 'lodash';
import { setCurrentWorkspaceInvitationsIds } from '../slices/currentWorkspace';
import { setInvitations } from '../slices/invitations';

export const getInvitationsByWorkspace = createAsyncThunk(
  'invitations/getInvitationsByWorkspace',
  async (payload, { dispatch }) => {
    const {
      workspaceId,
      setLoading = () => {},
      setErrors = () => {},
    } = payload;

    if (!_.isEmpty(workspaceId)) {
      try {
        const invitations = await api.workspace.getInvitationsByWorkspace({
          workspaceId,
          filter: {
            status: { eq: 'sent' },
          },
        });

        dispatch(
          setInvitations(
            invitations.data.getInvitationsByWorkspaceId.invitations
          )
        );
        dispatch(
          setCurrentWorkspaceInvitationsIds(
            invitations.data.getInvitationsByWorkspaceId.invitations.map(
              (invitation) => invitation.id
            )
          )
        );
        setLoading(false);
      } catch (error) {
        setErrors(error.message);
        setLoading(false);
      }
    } else {
      setErrors('generalError');
      setLoading(false);
    }
  }
);

export const getCurrentUserInvitations = createAsyncThunk(
  'invitations/getCurrentUserInvitations',
  async (_, { getState }) => {
    const { email } = getState().user;

    const userInvitations = await api.invitations.getInvitations({
      filter: {
        email: {
          eq: email,
        },
        status: {
          eq: 'sent',
        },
        workspaceId: {
          ne: null,
        },
      },
    });

    return userInvitations.data.getInvitations.invitations;
  }
);

export const getMembersInvitationsByCustomerId = createAsyncThunk(
  'invitations/getMembersInvitationsByCustomerId',
  async (payload) => {
    const { customerId } = payload;

    const userInvitations = await api.invitations.getInvitations({
      filter: {
        status: {
          eq: 'sent',
        },
        customerId: {
          eq: customerId,
        },
      },
    });

    return userInvitations.data.getInvitations.invitations;
  }
);

export const sendInvitation = createAsyncThunk(
  'invitations/sendWorkspaceInvitation',
  async (payload) => {
    const {
      data,
      formActions: { setErrors, setSubmitting, onComplete = () => {} },
    } = payload;

    if (!_.isEmpty(data.workspaceId)) {
      try {
        const invitation = await api.invitations.invitateUserToWorkspace({
          workspaceId: data.workspaceId,
          invitation: {
            email: data.email,
            resourceName: data.workspaceName,
            roleId: data.roleId,
          },
        });

        setSubmitting(false);
        onComplete(invitation);
      } catch (error) {
        if (error.message === 'USER_EXIST') {
          setErrors({
            afterSubmit: i18n.t('inviteUserToWorkspace.error.user.exist'),
          });
        } else if (error.message === 'ALREADY_INVITED') {
          setErrors({
            afterSubmit: i18n.t(
              'inviteUserToWorkspace.error.user.invited.already'
            ),
          });
        }
        setSubmitting(false);
      }
    } else {
      setErrors('generalError');
      setSubmitting(false);
    }
  }
);

export const cancelInvitationById = createAsyncThunk(
  'invitations/cancelInvitationById',
  async (payload) => {
    const { invitationId } = payload;
    const result = await api.invitations.cancelInvitationById({
      invitationId,
    });

    return result.data.deleteInvitation;
  }
);
